import { useAdminPayments } from "./hooks/useAdminPaymentsPage";

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

import { FileDownload, Search } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { paymentColumns } from "./components/AdminPaymentsPage.columns";

export default function AdminPaymentsPage() {
  const { payments, loading, search, setSearch, handleExportCSV } =
    useAdminPayments();

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        margin: "24px",
      }}
    >
      <CardContent>
        <Stack spacing={3}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", md: "center" }}
            spacing={2}
          >
            <Box>
              <Typography variant="h4" fontWeight={800} color="text.primary">
                Registro de pagos
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visualiza los pagos, revisa sus estados y filtra resultados
                desde un solo panel.
              </Typography>
            </Box>

            <Button
              startIcon={<FileDownload />}
              variant="contained"
              size="large"
              onClick={handleExportCSV}
              sx={{
                borderRadius: 3,
                px: 2.5,
                py: 1.1,
                boxShadow: `0 16px 28px ${alpha("#032B66", 0.22)}`,
              }}
            >
              Exportar CSV
            </Button>
          </Stack>

          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, md: 2.5 },
              borderRadius: 4,
              border: "1px solid rgba(15, 23, 42, 0.08)",
              bgcolor: "rgba(255,255,255,0.82)",
              backdropFilter: "blur(10px)",
            }}
          >
            <Stack spacing={2}>
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                alignItems={{ xs: "stretch", md: "center" }}
                justifyContent="space-between"
              >
                <TextField
                  size="small"
                  placeholder="Buscar por correo, estado o sesión de Stripe"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  fullWidth
                  sx={{ maxWidth: { md: 560 } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />

                <Chip
                  label={`${payments.length} pagos`}
                  variant="outlined"
                  sx={{
                    borderRadius: 999,
                    alignSelf: { xs: "flex-start", md: "auto" },
                  }}
                />
              </Stack>

              <Typography variant="body2" color="text.secondary">
                Filtra por correo, estado o sesión de Stripe para encontrar el
                registro que necesitas.
              </Typography>
            </Stack>
          </Paper>

          {loading ? (
            <Stack alignItems="center" sx={{ py: 4 }}>
              <CircularProgress />
            </Stack>
          ) : (
            <DataTable
              columns={paymentColumns}
              data={payments}
              pagination
              highlightOnHover
              striped
              responsive
              persistTableHead
              pointerOnHover
              customStyles={{
                table: {
                  style: { width: "100%" },
                },
                headCells: {
                  style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                  },
                },
              }}
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
